module.exports = __webpack_public_path__ + "media/images/symbols/colchester-new-logo-3c9868568d4992692514feefce51eec7.png";